import { clearAuth } from './auth/actions';
import { coreActions } from '@sonar-software/sonar-core';
import { put } from 'redux-saga/effects';
import { removeJWTToken } from '@sonar-software/sonar-ts-lib';
import { updateApplicationMaintenance } from './maintenance/actions';

import { ApplicationActionType, hardResetApplication, resetApplication, resetApplicationComplete } from './actions';
import {
	createWatcherSaga,
	error,
	SagaYieldType,
	ServiceUnavailableActionType,
	UnauthorizedErrorActionType
} from '@sonar-software/xuder';

export const hardResetApplicationWatcher = createWatcherSaga([
	{
		action: ApplicationActionType.HardReset,
		actionHandler: function* () {
			try {
				yield removeJWTToken();
				yield put(clearAuth());
				yield put(resetApplication());
			} catch (e) {
				yield put(error(e.message));
			}
		},
		type: SagaYieldType.Latest
	}
]);

export const softResetApplicationWatcher = createWatcherSaga([
	{
		action: ApplicationActionType.SoftReset,
		actionHandler: function* () {
			try {
				yield put(resetApplication());
				yield put(coreActions.requestGetCoreOrganizationsAll());
				yield put(coreActions.requestGetCoreOnboardingProgress());
				yield put(coreActions.requestGetCoreTags());
				yield put(resetApplicationComplete());
			} catch (e) {
				yield put(error(e.message));
			}
		},
		type: SagaYieldType.Latest
	}
]);

export const serviceUnavailableErrorWatcher = createWatcherSaga([
	{
		action: ServiceUnavailableActionType,
		actionHandler: function* () {
			try {
				yield put(updateApplicationMaintenance({ locked: true }));
			} catch (e) {
				yield put(error(e.message));
			}
		},
		type: SagaYieldType.Latest
	}
]);

export const unauthorizedErrorWatcher = createWatcherSaga([
	{
		action: UnauthorizedErrorActionType,
		actionHandler: function* () {
			try {
				yield put(hardResetApplication());
			} catch (e) {
				yield put(error(e.message));
			}
		},
		type: SagaYieldType.Latest
	}
]);
